/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { GetPassengersWaypointFragmentDoc } from '../../../../../ad-passenger-list/src/lib/utils/passenger-filters.hook'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdVehicleStreamBoardingPassengersWaypointFragment = {
  __typename?: 'FccWaypoint'
  id: string
  stop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en', string>>
  } | null
  stopWithServiceArea: {
    __typename?: 'Stop'
    id: string
    serviceArea: { __typename?: 'ServiceArea'; id: string }
  } | null
  actions: Array<
    | {
        __typename: 'FccWaypointDeliveryAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        ridePassengerInfo: {
          __typename?: 'FccRidePassengerInfo'
          customerId: string | null
          displayName: string | null
          boardingRequirements: {
            __typename?: 'FccBoardingRequirements'
            headCount: number
            childSeat: boolean
            wheelchair: boolean
          } | null
          impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
        } | null
        seats: {
          __typename?: 'FccWaypointSeatInfo'
          seats: number
          wheelchairs: number
          childSeats: number
          boosterSeats: number
        }
      }
    | { __typename?: 'FccWaypointHubReturnAction' }
    | {
        __typename: 'FccWaypointPickupAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
        notShownUpAt: string | null
        tripIsCancelled: boolean | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        ridePassengerInfo: {
          __typename?: 'FccRidePassengerInfo'
          customerId: string | null
          displayName: string | null
          boardingRequirements: {
            __typename?: 'FccBoardingRequirements'
            headCount: number
            childSeat: boolean
            wheelchair: boolean
          } | null
          impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
        } | null
        seats: {
          __typename?: 'FccWaypointSeatInfo'
          seats: number
          wheelchairs: number
          childSeats: number
          boosterSeats: number
        }
      }
    | { __typename?: 'FccWaypointReallocationAction' }
  >
}

export type AdVehicleStreamConfirmManualNoShowMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  tripId: Types.Scalars['ID']['input']
}>

export type AdVehicleStreamConfirmManualNoShowMutation = {
  __typename?: 'Mutation'
  fccConfirmManualNoShow: any | null
}

export type AdVehicleStreamConfirmManualCheckInMutationVariables = Types.Exact<{
  input: Types.FccManuallyCheckInPassengerInput
}>

export type AdVehicleStreamConfirmManualCheckInMutation = {
  __typename?: 'Mutation'
  fccManuallyCheckInPassenger: any | null
}

export const AdVehicleStreamBoardingPassengersWaypointFragmentDoc = gql`
    fragment AdVehicleStreamBoardingPassengersWaypoint on FccWaypoint {
  id
  ...GetPassengersWaypoint
}
    ${GetPassengersWaypointFragmentDoc}`
export const AdVehicleStreamConfirmManualNoShowDocument = gql`
    mutation AdVehicleStreamConfirmManualNoShow($vehicleId: ID!, $tripId: ID!) {
  fccConfirmManualNoShow(input: {tripId: $tripId, vehicleId: $vehicleId})
}
    `
export type AdVehicleStreamConfirmManualNoShowMutationFn =
  Apollo.MutationFunction<
    AdVehicleStreamConfirmManualNoShowMutation,
    AdVehicleStreamConfirmManualNoShowMutationVariables
  >

/**
 * __useAdVehicleStreamConfirmManualNoShowMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamConfirmManualNoShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamConfirmManualNoShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamConfirmManualNoShowMutation, { data, loading, error }] = useAdVehicleStreamConfirmManualNoShowMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useAdVehicleStreamConfirmManualNoShowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamConfirmManualNoShowMutation,
    AdVehicleStreamConfirmManualNoShowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamConfirmManualNoShowMutation,
    AdVehicleStreamConfirmManualNoShowMutationVariables
  >(AdVehicleStreamConfirmManualNoShowDocument, options)
}
export type AdVehicleStreamConfirmManualNoShowMutationHookResult = ReturnType<
  typeof useAdVehicleStreamConfirmManualNoShowMutation
>
export type AdVehicleStreamConfirmManualNoShowMutationResult =
  Apollo.MutationResult<AdVehicleStreamConfirmManualNoShowMutation>
export type AdVehicleStreamConfirmManualNoShowMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamConfirmManualNoShowMutation,
    AdVehicleStreamConfirmManualNoShowMutationVariables
  >
export const AdVehicleStreamConfirmManualCheckInDocument = gql`
    mutation AdVehicleStreamConfirmManualCheckIn($input: FccManuallyCheckInPassengerInput!) {
  fccManuallyCheckInPassenger(input: $input)
}
    `
export type AdVehicleStreamConfirmManualCheckInMutationFn =
  Apollo.MutationFunction<
    AdVehicleStreamConfirmManualCheckInMutation,
    AdVehicleStreamConfirmManualCheckInMutationVariables
  >

/**
 * __useAdVehicleStreamConfirmManualCheckInMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamConfirmManualCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamConfirmManualCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamConfirmManualCheckInMutation, { data, loading, error }] = useAdVehicleStreamConfirmManualCheckInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdVehicleStreamConfirmManualCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamConfirmManualCheckInMutation,
    AdVehicleStreamConfirmManualCheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamConfirmManualCheckInMutation,
    AdVehicleStreamConfirmManualCheckInMutationVariables
  >(AdVehicleStreamConfirmManualCheckInDocument, options)
}
export type AdVehicleStreamConfirmManualCheckInMutationHookResult = ReturnType<
  typeof useAdVehicleStreamConfirmManualCheckInMutation
>
export type AdVehicleStreamConfirmManualCheckInMutationResult =
  Apollo.MutationResult<AdVehicleStreamConfirmManualCheckInMutation>
export type AdVehicleStreamConfirmManualCheckInMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamConfirmManualCheckInMutation,
    AdVehicleStreamConfirmManualCheckInMutationVariables
  >
